export enum ERi1000PsrAlignmentLocation {
  Bottom,
  Top,
}

export interface Ri1000PsrAlignmentSetting {
  testLocations: ERi1000PsrAlignmentLocation[];
  includeZ: boolean;
  rotation: number;
}
